export default __webpack_public_path__ + "static/media/placeholder.155c20f7.svg";